import {createSlice} from "@reduxjs/toolkit";

const initialContestTransactionsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  exportData: [], 
  html5GamesCategories: [],
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const ContestTransactionsSlice = createSlice({
  
  name: "contestTransactions",
  initialState: initialContestTransactionsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },
    
    contestTransactionsList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    contestTransactionsExport: (state, action) => {
      const { exportData } = action.payload;
      state.exportData = exportData;
    },
    html5GamesCategoriesList: (state, action) => {
      const { html5GamesCategories } = action.payload;
      state.html5GamesCategories = html5GamesCategories;
    },
  }
});
